'use strict'

const jsonFile = require('./jsonfile')

jsonFile.outputJsonSync = require('./output-json-sync')
jsonFile.outputJson = require('./output-json')
// aliases
jsonFile.outputJSONSync = require('./output-json-sync')
jsonFile.outputJSON = require('./output-json')

module.exports = jsonFile



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/json/index.js
// module id = 1310
// module chunks = 0 1 2